const MuiFormLabel = {
  root: {
    fontSize: '1.6rem',
  },
};

export default MuiFormLabel;
